"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tag = exports.omit = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _htmlTags = _interopRequireDefault(require("html-tags"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var allPropTypes = Object.keys(_styledSystem.styles).filter(function (key) {
  return typeof _styledSystem.styles[key] === 'function';
}).reduce(function (a, key) {
  return Object.assign(a, _styledSystem.styles[key].propTypes);
}, {});
var omitProps = [].concat(_toConsumableArray(Object.keys(allPropTypes)), ['theme']);

var omit = function omit(obj, keys) {
  var next = {};

  for (var key in obj) {
    if (keys.indexOf(key) > -1) continue;
    next[key] = obj[key];
  }

  return next;
};

exports.omit = omit;

var Tag = _react.default.forwardRef(function (_ref, ref) {
  var _ref$is = _ref.is,
      Tag = _ref$is === void 0 ? 'div' : _ref$is,
      _ref$omitProps = _ref.omitProps,
      omitProps = _ref$omitProps === void 0 ? [] : _ref$omitProps,
      props = _objectWithoutProperties(_ref, ["is", "omitProps"]);

  return _react.default.createElement(Tag, _objectSpread({
    ref: ref
  }, omit(props, omitProps)));
});

exports.Tag = Tag;
Tag.displayName = 'Clean.div';
Tag.defaultProps = {
  omitProps: omitProps
};

_htmlTags.default.forEach(function (tag) {
  Tag[tag] = _react.default.forwardRef(function (props, ref) {
    return _react.default.createElement(Tag, _objectSpread({
      ref: ref,
      is: tag
    }, props));
  });
  Tag[tag].displayName = 'Clean.' + tag;
});

var _default = Tag;
exports.default = _default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-tag/dist.js
// module id = 5
// module chunks = 0